import { render } from "./Headlines.vue?vue&type=template&id=8fe6cefc&scoped=true"
import script from "./Headlines.vue?vue&type=script&lang=js"
export * from "./Headlines.vue?vue&type=script&lang=js"

import "./Headlines.vue?vue&type=style&index=0&id=8fe6cefc&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe6cefc"]])

export default __exports__